// import React, { useState } from 'react';
// import { ref, push, set } from 'firebase/database';
// import { database } from '../firebase';

// const AddParentForm = () => {
//   const [parentData, setParentData] = useState({
//     name: '',
//     mobile: ''
//   });
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [message, setMessage] = useState({ text: '', isError: false });

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setParentData(prev => ({
//       ...prev,
//       [name]: value
//     }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setIsSubmitting(true);
//     setMessage({ text: '', isError: false });

//     try {
//       // Create new parent entry
//       const parentsRef = ref(database, 'school/parents');
//       const newParentRef = push(parentsRef);
      
//       await set(newParentRef, {
//         name: parentData.name.trim(),
//         mobile: parentData.mobile.trim(),
//         createdAt: new Date().toISOString()
//       });

//       setMessage({ text: 'Parent added successfully!', isError: false });
//       // Reset form
//       setParentData({ name: '', mobile: '' });
//     } catch (error) {
//       console.error('Error adding parent:', error);
//       setMessage({ text: 'Failed to add parent. Please try again.', isError: true });
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   return (
//     <div style={{
//       maxWidth: '500px',
//       margin: '20px auto',
//       padding: '20px',
//       backgroundColor: '#f8f9fa',
//       borderRadius: '8px',
//       boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
//     }}>
//       <h2 style={{ marginBottom: '20px', color: '#333' }}>Add Parent</h2>
      
//       {message.text && (
//         <div style={{
//           padding: '10px',
//           backgroundColor: message.isError ? '#f8d7da' : '#d4edda',
//           color: message.isError ? '#721c24' : '#155724',
//           borderRadius: '4px',
//           marginBottom: '20px'
//         }}>
//           {message.text}
//         </div>
//       )}

//       <form onSubmit={handleSubmit}>
//         <div style={{ marginBottom: '15px' }}>
//           <label style={{
//             display: 'block',
//             marginBottom: '5px',
//             fontWeight: '500'
//           }}>
//             Parent Name *
//           </label>
//           <input
//             type="text"
//             name="name"
//             value={parentData.name}
//             onChange={handleChange}
//             required
//             minLength="3"
//             style={{
//               width: '100%',
//               padding: '10px',
//               border: '1px solid #ced4da',
//               borderRadius: '4px',
//               fontSize: '16px'
//             }}
//           />
//         </div>

//         <div style={{ marginBottom: '20px' }}>
//           <label style={{
//             display: 'block',
//             marginBottom: '5px',
//             fontWeight: '500'
//           }}>
//             Mobile Number *
//           </label>
//           <input
//             type="tel"
//             name="mobile"
//             value={parentData.mobile}
//             onChange={handleChange}
//             required
//             pattern="[0-9]{10}"
//             title="Please enter a 10-digit mobile number"
//             style={{
//               width: '100%',
//               padding: '10px',
//               border: '1px solid #ced4da',
//               borderRadius: '4px',
//               fontSize: '16px'
//             }}
//           />
//         </div>

//         <button
//           type="submit"
//           disabled={isSubmitting}
//           style={{
//             backgroundColor: '#007bff',
//             color: 'white',
//             padding: '12px',
//             border: 'none',
//             borderRadius: '4px',
//             cursor: 'pointer',
//             fontSize: '16px',
//             width: '100%',
//             transition: 'background-color 0.3s',
//             ':hover': {
//               backgroundColor: '#0069d9'
//             }
//           }}
//         >
//           {isSubmitting ? (
//             <span>Adding...</span>
//           ) : (
//             <span>Add Parent</span>
//           )}
//         </button>
//       </form>
//     </div>
//   );
// };

// export default AddParentForm;









// import React, { useState, useEffect } from 'react';
// import { ref, push, set, onValue, off } from 'firebase/database';
// import { database } from '../firebase';

// const AddParentForm = () => {
//   const [parentData, setParentData] = useState({
//     name: '',
//     mobile: ''
//   });
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [message, setMessage] = useState({ text: '', isError: false });
//   const [showTable, setShowTable] = useState(false);
//   const [parentsList, setParentsList] = useState([]);
//   const [isLoadingData, setIsLoadingData] = useState(false);

//   // Fetch parents data when showTable becomes true
//   useEffect(() => {
//     if (showTable) {
//       fetchParentsData();
//     }
//   }, [showTable]);

//   const fetchParentsData = () => {
//     setIsLoadingData(true);
//     const parentsRef = ref(database, 'school/parents');
    
//     onValue(parentsRef, (snapshot) => {
//       const data = snapshot.val();
//       if (data) {
//         const parentsArray = Object.entries(data).map(([id, parent]) => ({
//           id,
//           ...parent
//         }));
//         setParentsList(parentsArray);
//       } else {
//         setParentsList([]);
//       }
//       setIsLoadingData(false);
//     });

//     // Cleanup function
//     return () => off(parentsRef);
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setParentData(prev => ({
//       ...prev,
//       [name]: value
//     }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setIsSubmitting(true);
//     setMessage({ text: '', isError: false });

//     try {
//       const parentsRef = ref(database, 'school/parents');
//       const newParentRef = push(parentsRef);
      
//       await set(newParentRef, {
//         name: parentData.name.trim(),
//         mobile: parentData.mobile.trim(),
//         createdAt: new Date().toISOString()
//       });

//       setMessage({ text: 'Parent added successfully!', isError: false });
//       setParentData({ name: '', mobile: '' });
      
//       // Refresh the table if it's currently shown
//       if (showTable) {
//         fetchParentsData();
//       }
//     } catch (error) {
//       console.error('Error adding parent:', error);
//       setMessage({ text: 'Failed to add parent. Please try again.', isError: true });
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   const toggleTable = () => {
//     setShowTable(!showTable);
//   };

//   return (
//     <div style={{
//       maxWidth: '800px',
//       margin: '20px auto',
//       padding: '20px',
//       backgroundColor: '#f8f9fa',
//       borderRadius: '8px',
//       boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
//     }}>
//       <h2 style={{ marginBottom: '20px', color: '#333' }}>Parent Management</h2>
      
//       {message.text && (
//         <div style={{
//           padding: '10px',
//           backgroundColor: message.isError ? '#f8d7da' : '#d4edda',
//           color: message.isError ? '#721c24' : '#155724',
//           borderRadius: '4px',
//           marginBottom: '20px'
//         }}>
//           {message.text}
//         </div>
//       )}

//       <div style={{
//         display: 'grid',
//         gridTemplateColumns: '1fr 1fr',
//         gap: '20px',
//         marginBottom: '20px'
//       }}>
//         <div>
//           <h3 style={{ marginBottom: '15px' }}>Add New Parent</h3>
//           <form onSubmit={handleSubmit}>
//             <div style={{ marginBottom: '15px' }}>
//               <label style={{
//                 display: 'block',
//                 marginBottom: '5px',
//                 fontWeight: '500'
//               }}>
//                 Parent Name *
//               </label>
//               <input
//                 type="text"
//                 name="name"
//                 value={parentData.name}
//                 onChange={handleChange}
//                 required
//                 minLength="3"
//                 style={{
//                   width: '100%',
//                   padding: '10px',
//                   border: '1px solid #ced4da',
//                   borderRadius: '4px',
//                   fontSize: '16px'
//                 }}
//               />
//             </div>

//             <div style={{ marginBottom: '20px' }}>
//               <label style={{
//                 display: 'block',
//                 marginBottom: '5px',
//                 fontWeight: '500'
//               }}>
//                 Mobile Number *
//               </label>
//               <input
//                 type="tel"
//                 name="mobile"
//                 value={parentData.mobile}
//                 onChange={handleChange}
//                 required
//                 pattern="[0-9]{10}"
//                 title="Please enter a 10-digit mobile number"
//                 style={{
//                   width: '100%',
//                   padding: '10px',
//                   border: '1px solid #ced4da',
//                   borderRadius: '4px',
//                   fontSize: '16px'
//                 }}
//               />
//             </div>

//             <button
//               type="submit"
//               disabled={isSubmitting}
//               style={{
//                 backgroundColor: '#007bff',
//                 color: 'white',
//                 padding: '12px',
//                 border: 'none',
//                 borderRadius: '4px',
//                 cursor: 'pointer',
//                 fontSize: '16px',
//                 width: '100%',
//                 transition: 'background-color 0.3s',
//                 marginBottom: '10px',
//                 ':hover': {
//                   backgroundColor: '#0069d9'
//                 }
//               }}
//             >
//               {isSubmitting ? 'Adding...' : 'Add Parent'}
//             </button>
//           </form>
//         </div>

//         <div>
//           <h3 style={{ marginBottom: '15px' }}>Parent Data</h3>
//           <button
//             onClick={toggleTable}
//             style={{
//               backgroundColor: showTable ? '#6c757d' : '#28a745',
//               color: 'white',
//               padding: '12px',
//               border: 'none',
//               borderRadius: '4px',
//               cursor: 'pointer',
//               fontSize: '16px',
//               width: '100%',
//               transition: 'background-color 0.3s',
//               marginBottom: '20px',
//               ':hover': {
//                 backgroundColor: showTable ? '#5a6268' : '#218838'
//               }
//             }}
//           >
//             {showTable ? 'Hide Parents Data' : 'View Parents Data'}
//           </button>
//         </div>
//       </div>

//       {showTable && (
//         <div style={{
//           marginTop: '20px',
//           overflowX: 'auto'
//         }}>
//           {isLoadingData ? (
//             <div style={{ textAlign: 'center', padding: '20px' }}>
//               Loading parents data...
//             </div>
//           ) : parentsList.length > 0 ? (
//             <table style={{
//               width: '100%',
//               borderCollapse: 'collapse',
//               backgroundColor: 'white',
//               boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
//             }}>
//               <thead>
//                 <tr style={{
//                   backgroundColor: '#343a40',
//                   color: 'white'
//                 }}>
//                   <th style={{ padding: '12px', textAlign: 'left' }}>Name</th>
//                   <th style={{ padding: '12px', textAlign: 'left' }}>Mobile</th>
//                   <th style={{ padding: '12px', textAlign: 'left' }}>Created At</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {parentsList.map((parent) => (
//                   <tr key={parent.id} style={{
//                     borderBottom: '1px solid #dee2e6',
//                     ':hover': {
//                       backgroundColor: '#f8f9fa'
//                     }
//                   }}>
//                     <td style={{ padding: '12px' }}>{parent.name}</td>
//                     <td style={{ padding: '12px' }}>{parent.mobile}</td>
//                     <td style={{ padding: '12px' }}>
//                       {new Date(parent.createdAt).toLocaleString()}
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           ) : (
//             <div style={{
//               padding: '20px',
//               textAlign: 'center',
//               backgroundColor: 'white',
//               borderRadius: '4px',
//               boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
//             }}>
//               No parents data found
//             </div>
//           )}
//         </div>
//       )}
//     </div>
//   );
// };

// export default AddParentForm;





import React, { useState, useEffect } from 'react';
import { ref, push, set, onValue, off, update, remove } from 'firebase/database';
import { database } from '../firebase';

const AddParentForm = () => {
  const [parentData, setParentData] = useState({
    name: '',
    mobile: '',
    id: '' // For edit mode
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [message, setMessage] = useState({ text: '', isError: false });
  const [showTable, setShowTable] = useState(false);
  const [parentsList, setParentsList] = useState([]);
  const [isLoadingData, setIsLoadingData] = useState(false);
  const [isEditing, setIsEditing] = useState(false);

  // Fetch parents data when showTable becomes true
  useEffect(() => {
    if (showTable) {
      fetchParentsData();
    }
    return () => {
      const parentsRef = ref(database, 'school/parents');
      off(parentsRef);
    };
  }, [showTable]);

  const fetchParentsData = () => {
    setIsLoadingData(true);
    const parentsRef = ref(database, 'school/parents');
    
    onValue(parentsRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const parentsArray = Object.entries(data).map(([id, parent]) => ({
          id,
          ...parent
        }));
        setParentsList(parentsArray);
      } else {
        setParentsList([]);
      }
      setIsLoadingData(false);
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setParentData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setMessage({ text: '', isError: false });

    try {
      if (isEditing) {
        // Update existing parent
        const parentRef = ref(database, `school/parents/${parentData.id}`);
        await update(parentRef, {
          name: parentData.name.trim(),
          mobile: parentData.mobile.trim(),
          updatedAt: new Date().toISOString()
        });
        setMessage({ text: 'Parent updated successfully!', isError: false });
      } else {
        // Add new parent
        const parentsRef = ref(database, 'school/parents');
        const newParentRef = push(parentsRef);
        await set(newParentRef, {
          name: parentData.name.trim(),
          mobile: parentData.mobile.trim(),
          createdAt: new Date().toISOString()
        });
        setMessage({ text: 'Parent added successfully!', isError: false });
      }

      // Reset form
      setParentData({ name: '', mobile: '', id: '' });
      setIsEditing(false);
      
      // Refresh the table
      fetchParentsData();
    } catch (error) {
      console.error('Error saving parent:', error);
      setMessage({ text: `Failed to ${isEditing ? 'update' : 'add'} parent. Please try again.`, isError: true });
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleEdit = (parent) => {
    setParentData({
      name: parent.name,
      mobile: parent.mobile,
      id: parent.id
    });
    setIsEditing(true);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleDelete = async (parentId) => {
    if (window.confirm('Are you sure you want to delete this parent?')) {
      try {
        const parentRef = ref(database, `school/parents/${parentId}`);
        await remove(parentRef);
        setMessage({ text: 'Parent deleted successfully!', isError: false });
        fetchParentsData();
      } catch (error) {
        console.error('Error deleting parent:', error);
        setMessage({ text: 'Failed to delete parent.', isError: true });
      }
    }
  };

  const handleCancelEdit = () => {
    setParentData({ name: '', mobile: '', id: '' });
    setIsEditing(false);
  };

  const toggleTable = () => {
    setShowTable(!showTable);
  };

  return (
    <div style={{
      maxWidth: '1000px',
      margin: '20px auto',
      padding: '20px',
      backgroundColor: '#f8f9fa',
      borderRadius: '8px',
      boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
    }}>
      <h2 style={{ marginBottom: '20px', color: '#333' }}>Parent Management</h2>
      
      {message.text && (
        <div style={{
          padding: '10px',
          backgroundColor: message.isError ? '#f8d7da' : '#d4edda',
          color: message.isError ? '#721c24' : '#155724',
          borderRadius: '4px',
          marginBottom: '20px'
        }}>
          {message.text}
        </div>
      )}

      <div style={{
        backgroundColor: 'white',
        padding: '20px',
        borderRadius: '8px',
        boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
        marginBottom: '20px'
      }}>
        <h3 style={{ marginBottom: '15px', color: isEditing ? '#ffc107' : '#007bff' }}>
          {isEditing ? 'Edit Parent' : 'Add New Parent'}
        </h3>
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '15px' }}>
            <label style={{
              display: 'block',
              marginBottom: '5px',
              fontWeight: '500'
            }}>
              Parent Name *
            </label>
            <input
              type="text"
              name="name"
              value={parentData.name}
              onChange={handleChange}
              required
              minLength="3"
              style={{
                width: '100%',
                padding: '10px',
                border: '1px solid #ced4da',
                borderRadius: '4px',
                fontSize: '16px'
              }}
            />
          </div>

          <div style={{ marginBottom: '20px' }}>
            <label style={{
              display: 'block',
              marginBottom: '5px',
              fontWeight: '500'
            }}>
              Mobile Number *
            </label>
            <input
              type="tel"
              name="mobile"
              value={parentData.mobile}
              onChange={handleChange}
              required
              pattern="[0-9]{10}"
              title="Please enter a 10-digit mobile number"
              style={{
                width: '100%',
                padding: '10px',
                border: '1px solid #ced4da',
                borderRadius: '4px',
                fontSize: '16px'
              }}
            />
          </div>

          <div style={{
            display: 'flex',
            gap: '10px'
          }}>
            <button
              type="submit"
              disabled={isSubmitting}
              style={{
                backgroundColor: isEditing ? '#ffc107' : '#28a745',
                color: 'white',
                padding: '12px',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
                fontSize: '16px',
                flex: 1,
                transition: 'background-color 0.3s',
                ':hover': {
                  backgroundColor: isEditing ? '#e0a800' : '#218838'
                }
              }}
            >
              {isSubmitting ? (
                <span>{isEditing ? 'Updating...' : 'Adding...'}</span>
              ) : (
                <span>{isEditing ? 'Update Parent' : 'Add Parent'}</span>
              )}
            </button>

            {isEditing && (
              <button
                type="button"
                onClick={handleCancelEdit}
                style={{
                  backgroundColor: '#6c757d',
                  color: 'white',
                  padding: '12px',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  fontSize: '16px',
                  flex: 1,
                  transition: 'background-color 0.3s',
                  ':hover': {
                    backgroundColor: '#5a6268'
                  }
                }}
              >
                Cancel
              </button>
            )}
          </div>
        </form>
      </div>

      <div style={{
        backgroundColor: 'white',
        padding: '20px',
        borderRadius: '8px',
        boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
      }}>
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '20px'
        }}>
          <h3 style={{ margin: 0 }}>Parents Data</h3>
          <button
            onClick={toggleTable}
            style={{
              backgroundColor: showTable ? '#6c757d' : '#007bff',
              color: 'white',
              padding: '10px 15px',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              fontSize: '14px',
              transition: 'background-color 0.3s',
              ':hover': {
                backgroundColor: showTable ? '#5a6268' : '#0069d9'
              }
            }}
          >
            {showTable ? 'Hide Data' : 'View Data'}
          </button>
        </div>

        {showTable && (
          <div style={{ overflowX: 'auto' }}>
            {isLoadingData ? (
              <div style={{ textAlign: 'center', padding: '20px' }}>
                Loading parents data...
              </div>
            ) : parentsList.length > 0 ? (
              <table style={{
                width: '100%',
                borderCollapse: 'collapse',
                backgroundColor: 'white'
              }}>
                <thead>
                  <tr style={{
                    backgroundColor: '#343a40',
                    color: 'white'
                  }}>
                    <th style={{ padding: '12px', textAlign: 'left' }}>Name</th>
                    <th style={{ padding: '12px', textAlign: 'left' }}>Mobile</th>
                    <th style={{ padding: '12px', textAlign: 'left' }}>Created At</th>
                    <th style={{ padding: '12px', textAlign: 'left' }}>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {parentsList.map((parent) => (
                    <tr key={parent.id} style={{
                      borderBottom: '1px solid #dee2e6',
                      ':hover': {
                        backgroundColor: '#f8f9fa'
                      }
                    }}>
                      <td style={{ padding: '12px' }}>{parent.name}</td>
                      <td style={{ padding: '12px' }}>{parent.mobile}</td>
                      <td style={{ padding: '12px' }}>
                        {new Date(parent.createdAt).toLocaleString()}
                      </td>
                      <td style={{ padding: '12px' }}>
                        <div style={{
                          display: 'flex',
                          gap: '8px'
                        }}>
                          <button
                            onClick={() => handleEdit(parent)}
                            style={{
                              backgroundColor: '#17a2b8',
                              color: 'white',
                              padding: '6px 12px',
                              border: 'none',
                              borderRadius: '4px',
                              cursor: 'pointer',
                              fontSize: '14px',
                              transition: 'background-color 0.3s',
                              ':hover': {
                                backgroundColor: '#138496'
                              }
                            }}
                          >
                            Edit
                          </button>
                          <button
                            onClick={() => handleDelete(parent.id)}
                            style={{
                              backgroundColor: '#dc3545',
                              color: 'white',
                              padding: '6px 12px',
                              border: 'none',
                              borderRadius: '4px',
                              cursor: 'pointer',
                              fontSize: '14px',
                              transition: 'background-color 0.3s',
                              ':hover': {
                                backgroundColor: '#c82333'
                              }
                            }}
                          >
                            Delete
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <div style={{
                padding: '20px',
                textAlign: 'center',
                backgroundColor: '#f8f9fa',
                borderRadius: '4px'
              }}>
                No parents data found
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default AddParentForm;